import React, {useEffect, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';

export const AddAccountRedirectReplatforming: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({pathname: './check'});
  }, []);
  return null;
};
